import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PotentialDealsSidebarSmartComponent } from './potential-deals-sidebar-smart/potential-deals-sidebar-smart.component';
import { PotentialDealsModule } from 'app/potential-deals/potential-deals.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { CollapsibleContainerModule } from 'ng2-app/borrower-fd/borrower-fd-sidebar/collapsible-container/collapsible-container.module';

@NgModule({
  declarations: [
    PotentialDealsSidebarSmartComponent,
  ],
  imports: [
    CollapsibleContainerModule,
    CommonModule,
    MatProgressSpinnerModule,
    PotentialDealsModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyMaterialModule,
    MatDividerModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatButtonModule,
    MatBadgeModule,
    MatTooltipModule,
    MatDialogModule,
    MatIconModule
  ],
  exports: [PotentialDealsSidebarSmartComponent]
})
export class PotentialDealsSidebarModule { }
